// extracted by mini-css-extract-plugin
export default {"transactionInput":"transaction_transactionInput__1wtTp"};